import { useAuth } from './useAuth';

export type AdminRole = 'super_admin' | 'admin' | 'viewer' | null;

export function useAdminAuth() {
  const { user, isLoading, isDemo } = useAuth();

  if (isDemo) {
    return {
      isAdmin: true,
      isSuperAdmin: true,
      role: 'super_admin' as const,
      loading: false,
      error: null,
      refresh: () => {},
    };
  }

  const role = (user?.adminRole as AdminRole) || null;
  const isAdmin = role === 'super_admin' || role === 'admin';
  const isSuperAdmin = role === 'super_admin';

  return {
    isAdmin,
    isSuperAdmin,
    role,
    loading: isLoading,
    error: null,
    refresh: () => {},
  };
}
